import React from 'react';
import PhotoEntery from './PhotoEntry';
import entries from './data/photo-entries';

class AlbumMaker extends React.Component {

    render() {

        console.log(entries);

        return (
            <div className="flex-container">
                {
                entries.itemlist.map((photo) => {
                    return <PhotoEntery key={photo.src} src={photo.src} location={photo.location} caption={photo.caption}/>
                })
                }
               
            </div>
        )
    }
}

export default AlbumMaker;